import React, { useEffect, useState } from "react";
import $ from "jquery";
import axios, { all } from "axios";
import { Link, useOutletContext, useSearchParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { MaterialReactTable } from "material-react-table";
import { useNavigate } from "react-router-dom";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { decodeHtml } from "../../../utils/decodeHtml";
import { openInAppTab } from "../../../utils/tabNavigation";

function Invoice2ndPending() {
  const PINE_BASE_URL = process.env.REACT_APP_PINE_BASE_URL;
  const REACT_APP_BASE_URL = process.env.REACT_APP_BASE_URL;
  const REACT_APP_API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [searchParams] = useSearchParams();
  const { setGlobalLoading, token } = useOutletContext();
  const [showBuHeadModal, setShowBuHeadModal] = useState(false);
  const [selectedRole, setSelectedRole] = useState(null);
  const [selectedOwner, setSelectedOwner] = useState("");

  const user = JSON.parse(localStorage.getItem("user")) || {};
  const searchUserId = searchParams.get("user_id");  
  const navigate = useNavigate();
  const {
    register,
    setValue,
    formState: { errors },
    handleSubmit,
    reset,
  } = useForm();
  const [data, setData] = useState([]);
  const [options, setoptions] = useState([]);
  const [selectedRoleManager, setSelectedRoleManager] = useState("");

  const formatNumber = (num) => {
    if (!num) return 0;
    return new Intl.NumberFormat("en-IN").format(num);
    };

  const get_pending_data = async () => {
  try {
    setGlobalLoading(true);

    const response = await axios.get(
      `${REACT_APP_API_BASE_URL}/reports/get_pending_2nd_retainer`, 
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
    });

    const d = response.data;

    if (response.status === 200) {
      setoptions(d?.pending_2nd_retainer || []);
    }
  } catch (error) {
    console.error(error);
  } finally {
    setGlobalLoading(false);
  }
  };

  useEffect(() => {
    get_pending_data();
  }, []);

  const roleManagers = [
    ...new Set(
        options
        .map((item) => item.bu_head)
        .filter(Boolean)
    ),
    ];
   const filteredData = selectedRoleManager
  ? options.filter(
      (item) => item.bu_head === selectedRoleManager
    )
  : options; 

   const totalAmount = filteredData.reduce(
    (sum, item) =>
        sum +
        Number(item.amount || 0) *
        Number(item.conversion_rate || 1),
    0
    );

      // Excel Download
    const downloadExcel = () => {
        const excelData = filteredData.map((item, index) => ({
          Sr_No: index + 1,
          Client: item.client,
          Role: item.role,
          Status: item.status,
          BU_Head: item.bu_head,
          First_Retainer_Raised: item.raised_date || "-",
          First_Retainer_Issued: item.issue_date || "-",
          Amount:
            Number(item.amount || 0) *
            Number(item.conversion_rate || 1),
        }));
    
        const worksheet = XLSX.utils.json_to_sheet(excelData);
    
        const workbook = XLSX.utils.book_new();
    
        XLSX.utils.book_append_sheet(
          workbook,
          worksheet,
          "Pending Revenue",
        );
    
        XLSX.writeFile(
          workbook,
          "2nd_Retainer_Not_In_PINE.xlsx",
        );
      };

  return (
    <>
      <div className="content card">
        <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-1">
            <h5 className="mb-1">2nd Retainer Not on PINE</h5>
            <div className="d-flex align-items-center gap-3">
                <small className="fw-bold" style={{ fontSize: "14px" }}>
                  Total Revenue : ₹{" "}
                  {totalAmount.toLocaleString("en-IN", {
                    maximumFractionDigits: 0,
                  })}
                </small>

                <select className="form-select form-select-sm" style={{ width: "220px" }} value={selectedRoleManager}
                    onChange={(e) => setSelectedRoleManager(e.target.value)}
                >
                    <option value="">All Role Managers</option>
                {roleManagers.map((manager) => (
                    <option key={manager} value={manager}>
                    {manager}
                    </option>
                ))}
                </select>

                {/* Excel Download */}
                <button type="button" className="btn btn-sm btn-success" onClick={downloadExcel}>
                  Export Excel
                </button>
            </div>
        </div>
        <div className="border-0">
          <div className="row">
            <div className="col-xxl-12 d-flex">
                {filteredData.length === 0 ? (
                <div className="text-center text-muted py-4">
                    No pending revenue found
                </div>
                ) : (
                <div className="table-responsive">
                    <table className="table table-sm table-hover table-bordered align-middle">
                    <thead className="table-light">
                        <tr>
                        <th>#</th>
                        <th>Client</th>
                        <th>Role</th>
                        <th>Status</th>
                        <th>BU Head</th>
                        <th>1st Ret Raised</th>
                        <th>1st Ret Issued</th>
                        <th className="text-end">Amount</th>
                        </tr>
                    </thead>

                    <tbody>
                        {filteredData.map((item, index) => {
                        const amount =
                            Number(item.amount || 0) *
                            Number(item.conversion_rate || 1);

                        return (
                            <tr key={index}>
                            <td>{index + 1}</td>
                            <td>
                                <a href={`/client/view/${item.company_id}`} onClick={(e) => { e.preventDefault(); openInAppTab(`/client/view/${item.company_id}`); }} target="_blank" rel="noreferrer">
                                {item.client}
                                </a>
                            </td>
                            <td>
                                <a href={`/role/view/${item.role_id}`} target="_blank" rel="noreferrer" title={decodeHtml(item.role)} onClick={(event) => {
                                  event.preventDefault();
                                  openInAppTab(
                                    `/role/view/${item.role_id}`,
                                  );
                                }}>
                                {item.role.length > 55 ? `${item.role.substring(0, 55)}...` : decodeHtml(item.role)}
                                </a>
                            </td>
                            <td>
                                <span
                                className={`badge ${
                                    item.status === "Active"
                                    ? "bg-success"
                                    : item.status === "On Hold"
                                        ? "bg-warning text-dark"
                                        : item.status === "Closed"
                                        ? "bg-danger"
                                        : "bg-secondary"
                                }`}
                                >
                                {item.status}
                                </span>
                            </td>

                            <td>{item.bu_head}</td>

                            <td>{item.raised_date || "-"}</td>

                            <td>{item.issue_date || "-"}</td>

                            <td className="text-end fw-bold">
                                ₹{" "}
                                {amount.toLocaleString("en-IN", {
                                maximumFractionDigits: 0,
                                })}
                            </td>
                            </tr>
                        );
                        })}
                    </tbody>

                    <tfoot className="table-light">
                        <tr>
                        <th colSpan="7" className="text-end">
                            Total
                        </th>

                        <th className="text-end">
                            ₹{" "}
                            {totalAmount.toLocaleString("en-IN", {
                            maximumFractionDigits: 0,
                            })}
                        </th>
                        </tr>
                    </tfoot>
                    </table>
                </div>
                )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default Invoice2ndPending;
